export default "__VITE_ASSET__DQhpJ8c1__"